import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './TaskCompleteConfirmModal.css';

interface TaskCompleteConfirmModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TaskCompleteConfirmModal: React.FC<TaskCompleteConfirmModalProps> = ({
  isOpen,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen && !isLoading) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, isLoading, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="task-complete-confirm-modal-overlay" onClick={() => !isLoading && onClose()}>
      <div className="task-complete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="task-complete-confirm-modal-close"
          onClick={onClose}
          disabled={isLoading}
          aria-label="Закрыть"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <div className="task-complete-confirm-modal-icon" aria-hidden>
          <img src="/icons/modals/TaskModal/Check.svg" alt="" />
        </div>

        <h3 className="task-complete-confirm-modal-message">Завершить задачу?</h3>
        <p className="task-complete-confirm-modal-subtext">
          После подтверждения задача будет помечена как завершённая и перейдёт в архив завершённых.
        </p>

        <div className="task-complete-confirm-modal-actions">
          <button
            type="button"
            className="task-complete-confirm-modal-confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Завершение…' : 'Завершить'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default TaskCompleteConfirmModal;
